import { getBranchStocksSkus } from '../../services/api/branchStock.api';
import { GET_BRANCHES_SKU_LIST_REQUEST, GET_BRANCHES_SKU_LIST_SUCCESS, GET_BRANCHES_SKU_LIST_FAILURE } from '../types';
import { transformStockBranchesSkus } from '../../transforms/stock';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockBranchesSkus([]),
		pagination: transformPagination({}),
	},

	mutations: {
		[GET_BRANCHES_SKU_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_BRANCHES_SKU_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformStockBranchesSkus(data);
			state.pagination = transformPagination(meta);
		},
		[GET_BRANCHES_SKU_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBranchStocksSkus({ commit }, { id = null, params = {} }) {
			try {
				const _params = {
					keyword: params.keyword,
					sort_by: params.sort_by,
					sort_direction: params.sort_direction,
					'filters[category_id]': params.category,
					'filters[brand_id]': params.brand,
					'filters[status]': params.status,
					'filters[product_type]': params.type,
					page: params.page,
					per_page: 30,
				};
				commit(GET_BRANCHES_SKU_LIST_REQUEST);
				const { data } = await getBranchStocksSkus(_params, id);
				commit(GET_BRANCHES_SKU_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_BRANCHES_SKU_LIST_FAILURE, error);
			}
		},
	},
};